<div class="loader">
  <div class="loader__header">
    <div class="loader__title">{{ title() }}</div>
    <div class="loader__subtitle">{{ subtitle() }}</div>
  </div>

  <fa-icon class="loader__spinner" icon="spinner-third" animation="spin" />

  <div class="loader-carousel">
    @for (item of items(); track item; let i = $index) {
      <div
        class="loader-carousel__item"
        [class.loader-carousel__item--visible]="step() > i"
      >
        <fa-icon class="loader-carousel__item__icon" [icon]="item.icon" />
        <div class="loader-carousel__item__text">{{ item.text }}</div>
      </div>
    }
  </div>
</div>
